import React from "react";
import { TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";

export default function DefaultTemporaryLocation({
  value,
  onChange,
  margin = "dense",
  variant = "filled",
  InputLabelProps,
}) {
  const { t } = useTranslation();
  return (
    <>
      <TextField
        label={t("Lagerort")}
        margin={margin}
        variant={variant}
        InputLabelProps={InputLabelProps}
        fullWidth
        value={value?.location ?? ""}
        onChange={(e) =>
          onChange({
            location: e.target.value,
            compartment: value?.compartment ?? "",
          })
        }
        autoFocus
      />
      <TextField
        label={t("Fach")}
        margin={margin}
        variant={variant}
        InputLabelProps={InputLabelProps}
        fullWidth
        value={value?.compartment ?? ""}
        onChange={(e) =>
          onChange({
            location: value?.location ?? "",
            compartment: e.target.value,
          })
        }
      />
    </>
  );
}
